import { useQuery, useMutation, useQueryClient } from "react-query";
import axios from "axios";
import { useContext } from "react";
import { AuthContext } from "../../../Context/AuthContext";

const api = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export const useWishlist = () => {
  const { token } = useContext(AuthContext);
  return useQuery(
    "wishlist",
    async () => {
      const res = await axios.get(`${process.env.REACT_APP_SERVER_URL}/customer/wishlist`, api(token));
      return res.data.items;
    },
    { enabled: !!token }
  );
};

export const useWishlistCheck = (productId) => {
  const { token } = useContext(AuthContext);
  return useQuery(
    ["wishlistCheck", productId],
    async () => {
      const res = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/customer/wishlist/check/${productId}`,
        api(token)
      );
      return res.data.saved;
    },
    { enabled: !!token && !!productId }
  );
};

export const useToggleWishlist = () => {
  const { token } = useContext(AuthContext);
  const qc = useQueryClient();
  return useMutation(
    async ({ productId, saved }) => {
      if (saved) {
        await axios.delete(`${process.env.REACT_APP_SERVER_URL}/customer/wishlist/${productId}`, api(token));
      } else {
        await axios.post(`${process.env.REACT_APP_SERVER_URL}/customer/wishlist`, { productId }, api(token));
      }
    },
    {
      onSuccess: (_, { productId }) => {
        qc.invalidateQueries("wishlist");
        qc.invalidateQueries(["wishlistCheck", productId]);
      },
    }
  );
};
